import type { DetailListItem } from '@presentation/components';
import { DetailList } from '@presentation/components';
import dayjs from 'dayjs';
import { capitalize } from 'lodash/fp';
import type { FC } from 'react';
import { RiCheckboxBlankCircleFill, RiCheckboxBlankCircleLine } from 'react-icons/ri';
import * as Styled from './styled';
import type { DetailListScheduleProps } from './types';

export * from './types';

export const DetailListSchedule: FC<DetailListScheduleProps> = (props) => {
  const { times, ...rest } = props;
  return (
    <DetailList
      wrap={false}
      {...rest}
      items={new Array(7).fill(undefined).map((_, index) => {
        const day = dayjs().set('day', index + 1);
        const isToday = dayjs().get('day') === index + 1;
        return {
          label: (
            <Styled.GrayscaleWrapper greyed={index >= times.length}>
              <Styled.ConditionnalBold isBold={isToday}>
                {capitalize(day.format('dddd'))}
              </Styled.ConditionnalBold>
            </Styled.GrayscaleWrapper>
          ),
          value: (
            <Styled.GrayscaleWrapper greyed={index >= times.length}>
              <Styled.ConditionnalBold isBold={isToday}>
                {times[index] ? times[index]?.join('\n') ?? '' : '-'}
              </Styled.ConditionnalBold>
            </Styled.GrayscaleWrapper>
          ),
          labelIcon: (
            <Styled.GrayscaleWrapper greyed={index >= times.length}>
              {dayjs().get('day') ===
              dayjs()
                .set('day', index + 1)
                .get('day') ? (
                <RiCheckboxBlankCircleFill />
              ) : (
                <RiCheckboxBlankCircleLine />
              )}
            </Styled.GrayscaleWrapper>
          ),
        } as DetailListItem;
      })}
    />
  );
};
